export default {
    title: "Katalog",
    noAvailableItems: "Žádné produkty nelze objednat."
}